import { Grid, Typography } from '@material-ui/core'
import React from 'react'

import { useStyles } from './styles'

const Banner = () => {
  const classes = useStyles()

  return (
    <Grid className={classes.mainView}>
      <Typography className={classes.bannerText}>
        This site is optimized for mobile devices. For a better experience use this tool from a tablet or phone!
      </Typography>
    </Grid>
  )
}

export { Banner }
